import styled from "styled-components";

export const Circle = styled.circle`
    stroke: ${(props) => props.color};
    fill: ${(props) => props.fill};
`;

export const Path = styled.path`
    stroke: ${(props) => props.color};
`;

export const Icon = styled.svg`
    fill: none;
    &:hover {
        ${Circle} {
            fill: ${(props) =>
                props.hover && !props.disabled
                    ? props.circleFillHoverColor
                    : props.circleFillColor};
            stroke: ${(props) =>
                props.hover && !props.disabled
                    ? props.circleStrokeHoverColor
                    : props.circleStrokeColor};
        }
        ${Path} {
            stroke: ${(props) =>
                props.hover && !props.disabled
                    ? props.arrowStrokeHoverColor
                    : props.arrowStrokeColor};
        }
    }
    ${Path} {
        stroke: ${(props) => props.disabled && globalThis.config.colors.gray4};

}
cursor:${(props) => (props.disabled ? "auto" : "pointer")};,
`;
